import _ from 'lodash';

type DeepKeys<T, P extends keyof T = keyof T> = P extends string
  ? T[P] extends Record<string, any>
    ? P | `${P}.${DeepKeys<T[P]>}`
    : P
  : never;

// A typed version of _.keyBy
function keyBy<T, K extends DeepKeys<T>>(
  list: Array<Partial<T>>,
  key: K
): Record<string, Partial<T>> {
  // need to escape lodash's crappy typings, sorry
  return _.keyBy(list, key as any);
}

// A typed version of _.uniqBy
function uniqBy<T, K extends DeepKeys<T>>(list: Array<Partial<T>>, key: K): Array<Partial<T>> {
  return _.uniqBy(list, key);
}

export { keyBy, uniqBy };
